import * as React from 'react';
import * as Sebrae from '@sebrae/react-core';
import { BaSeHeader, BaSeBreakpointContext } from '@base/react';
import { ReactComponent as DesktopLogo } from '../../images/logo-horizontal-negativo.svg';
import { ReactComponent as MobileLogo } from '../../images/logo-vertical-negativo.svg';
import {
  azulFluxoCaixa,
  ContentFilledContainer,
  FullWidthDiv,
  MarginDelimitedBreakpoint,
  WrapperDesktopLogo,
  WrapperHeader,
  WrapperMobileLogo,
} from './layout-styled';
import { Footer } from './footer';
import { AccessibilityBar } from './accessibility-bar';

const LogoComponent = ({ clickCallback }) => {
  const { inTablet } = React.useContext(BaSeBreakpointContext);

  return (
    <FullWidthDiv>
      {inTablet && (
        <WrapperDesktopLogo onClick={clickCallback}>
          <DesktopLogo />
        </WrapperDesktopLogo>
      )}
    </FullWidthDiv>
  );
};

const TextLogo = ({ callback }) => (
  <WrapperMobileLogo onClick={callback}>
    <MobileLogo />
  </WrapperMobileLogo>
);

export const LayoutPublic = ({ children }) => {
  const { navigateTo } = Sebrae.useRouter();
  const { inDesktop } = React.useContext(BaSeBreakpointContext);

  return (
    <>
      <AccessibilityBar />
      <WrapperHeader>
        <BaSeHeader
          backgroundColor={azulFluxoCaixa}
          systemName=""
          delimitedOnBreakpoint="desktop"
          systemLogo={() =>
            !inDesktop ? (
              <TextLogo
                callback={() => {
                  localStorage.clear();
                  navigateTo('/');
                }}
              />
            ) : (
              <></>
            )
          }
          customComponents={[
            {
              component: () => (
                <LogoComponent
                  clickCallback={() => {
                    localStorage.clear();
                    navigateTo('/');
                  }}
                />
              ),
              showOnExpanded: true,
              showOnSidebar: true,
            },
          ]}
        />
      </WrapperHeader>
      <ContentFilledContainer>{children}</ContentFilledContainer>
      <MarginDelimitedBreakpoint>
        <Footer />
      </MarginDelimitedBreakpoint>
    </>
  );
};
